<script setup lang="ts">
import { defineAsyncComponent, onMounted, nextTick } from 'vue';
import util from '@/Utils/util';
import { useRoute } from 'vue-router';

const BulkCheckSend = defineAsyncComponent(() => import('./Payments/Checks/BulkCheckSend.vue') as any);
const CheckBatchStatus = defineAsyncComponent(() => import('./Payments/Checks/CheckBatchStatus.vue') as any);

onMounted(async () => {
  const route = useRoute();
  const hash = route.hash;

  await nextTick();
  util.moveScrollComponent(hash);
});
</script>

<template>
  <div class="page-content checks">
    <div class="row">
      <div class="col-md-6 col-sm-6 col-xs-12">
        <bulk-check-send />
      </div>
      <div class="col-md-6 col-sm-6 col-xs-12">
        <check-batch-status />
      </div>
    </div>
  </div>
</template>
